import script from "./PublishingView.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishingView.vue?vue&type=script&setup=true&lang=js"

import "./PublishingView.vue?vue&type=style&index=0&id=012d1873&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012d1873"]])

export default __exports__